import {
  HttpClient,
  HttpErrorResponse,
  HttpEventType,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { filter, switchMap, take, catchError } from 'rxjs/operators';
import { UserService } from 'src/app/core/common-services/user.services';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseApiService<T> {
  private isRefreshTokenInProgress: boolean = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private userService: UserService
  ) {}

  public Post(destinationUrl: string, body?: any, options?: {}): Observable<T> {
    return this.request<T>('post', destinationUrl, body, options);
  }

  public Patch(
    destinationUrl: string,
    body?: any,
    options?: {}
  ): Observable<T> {
    return this.request<T>('patch', destinationUrl, body, options);
  }

  public Put(destinationUrl: string, body?: any, options?: {}): Observable<T> {
    return this.request<T>('put', destinationUrl, body, options);
  }

  public Get(destinationUrl: string, options?: {}): Observable<T> {
    return this.request<T>('get', destinationUrl, undefined, options);
  }

  public Delete(destinationUrl: string, options?: {}): Observable<T> {
    return this.request<T>('delete', destinationUrl, undefined, options);
  }

  private request<T>(
    method: string,
    url: string,
    body: any,
    options?: any
  ): Observable<T> {
    return this.performRequest<T>(method, url, body, options);
  }

  // private shouldRefreshToken(url: string): boolean |undefined{

  //   return this.isRefreshTokenInProgress === false &&
  //     this.userService.isLoggedIn() &&
  //     this.userService.currentUserCredantials.expiryTokenDate &&
  //     new Date(this.userService.currentUserCredantials.expiryTokenDate).getTime() <= new Date().getTime() &&
  //     !url.includes('RefreshToken') &&
  //     !url.includes('Login') &&
  //     !url.includes('Logout');
  // }

  private performRequest<T>(
    method: string,
    url: string,
    body: any,
    options?: any
  ): Observable<T> {
    if (options == undefined) options = {};

    let headers = options.headers || new HttpHeaders();
    headers = headers.set('Accept-Language', 'en-US');

    const token = this.userService.currentUserCredantials?.token;
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    options.headers = headers;

    return new Observable((subscriber) => {
      this.httpClient
        .request<T>(new HttpRequest(method, url, body, options))
        .subscribe(
          (response: any) => {
            if (response.type == HttpEventType.Response) {
              subscriber.next(response.body);
            }
          },
          (error: any) => {
            if (
              error?.error?.data?.message ==
              `You Don't Have Privilege For This Action`
            ) {
              this.router.navigate(['/kyc/kyc-required']);
            }
            subscriber.error(error);
          }
        );
    });
  }

  // private refreshToken(): Observable<any> {
  //   if (this.isRefreshTokenInProgress) {
  //     return this.refreshTokenSubject.pipe(
  //       filter(result => result !== null),
  //       take(1)
  //     );
  //   } else {
  //     this.isRefreshTokenInProgress = true;
  //     this.refreshTokenSubject.next(null);

  //     const refreshTokenInput = {
  //       userId: this.userService.currentUserCredantials.userId!,
  //       refreshToken: this.userService.currentUserCredantials.refreshToken!
  //     };

  //     const refreshTokenApiUrl = `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/AccountDashboard/RefreshToken`;

  //     return new Observable((subscriber) => {
  //       this.httpClient.post(refreshTokenApiUrl, refreshTokenInput).subscribe(
  //         (res: any) => {
  //           this.isRefreshTokenInProgress = false;
  //           if (res.data) {
  //             this.userService.currentUserCredantials = res.data;
  //             this.refreshTokenSubject.next(res.data);
  //             subscriber.next(res.data);
  //           } else {
  //             this.isRefreshTokenInProgress = false;
  //             this.userService.logout();
  //             subscriber.complete();
  //           }
  //         },
  //         (error) => {
  //           this.isRefreshTokenInProgress = false;
  //           this.userService.logout();
  //           this.refreshTokenSubject.next(null);
  //           subscriber.error(error);
  //         }
  //       );
  //     });
  //   }
  // }
}
